import React from 'react'
import PropTypes from 'prop-types'
import './styles.css'

export default class MediaQuery extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    size: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string
  }

  static defaultProps = {
    size: 'desktop'
  }

  render() {
    const {size, style, className} = this.props
    return (
      <div style={style} className={`MediaQuery-${size} ${className || ''}`}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/MediaQuery/index.js